module.exports = __webpack_public_path__ + "static/media/car.619c1f58.svg";